<div class="flex items-center gap-2 px-3 py-2.5 rounded bg-[var(--talos-bg)] transition-all" style="border:1px solid rgb(var(--talos-ink-rgb) / 0.15)">
  <lucide-icon [img]="SearchIcon" [size]="16" color="rgb(var(--talos-ink-rgb) / 0.35)" class="shrink-0" />
  <input
    type="text"
    [value]="value()"
    [placeholder]="placeholder()"
    class="flex-1 bg-transparent border-0 outline-none text-sm text-talos-ink min-w-0"
    style="color:var(--talos-ink)"
    placeholder-style="color:rgb(var(--talos-ink-rgb) / 0.35)"
    (input)="onInput($event)"
  />
  @if (value()) {
    <button
      type="button"
      class="shrink-0 w-4 h-4 flex items-center justify-center rounded border-0 cursor-pointer p-0 transition-colors hover:bg-talos-line"
      style="background:rgb(var(--talos-ink-rgb) / 0.08)"
      aria-label="Clear search"
      (click)="clear()">
      <lucide-icon [img]="XIcon" [size]="10" color="rgb(var(--talos-ink-rgb) / 0.6)" />
    </button>
  }
</div>
